import React from "react";

interface CollapsibleProps {
  title: string;
  open: boolean;
  onToggle: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}

const Collapsible: React.FC<CollapsibleProps> = ({
  title,
  open,
  onToggle,
  disabled,
  children,
}) => {
  return (
    <div
      style={{
        border: "1px solid #D2D6DD",
        borderRadius: "8px",
        marginBottom: "16px",
        background: disabled ? "#F5F5F5" : "#FFFFFF",
        opacity: disabled ? 0.6 : 1,
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
        transition: "all 0.2s ease",
      }}
    >
      <button
        onClick={onToggle}
        disabled={disabled}
        style={{
          width: "100%",
          padding: "14px 18px",
          textAlign: "left",
          background: "#FFFFFF",
          border: "none",
          fontWeight: "600",
          fontSize: "15px",
          cursor: disabled ? "not-allowed" : "pointer",
          outline: "none",
          color: disabled ? "#999999" : "#1F242B",
          fontFamily: '"Roboto", sans-serif',
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          transition: "background-color 0.2s ease",
        }}
        onMouseEnter={(e) =>
          !disabled && (e.currentTarget.style.backgroundColor = "#F8F9FA")
        }
        onMouseLeave={(e) =>
          !disabled && (e.currentTarget.style.backgroundColor = "#FFFFFF")
        }
        aria-expanded={open}
      >
        <span
          style={{
            color: disabled ? "#999999" : "#1F242B",
            flex: 1,
          }}
        >
          {title}
        </span>
        <span
          style={{
            fontSize: "14px",
            color: "#666666",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s ease",
            display: "inline-block",
            lineHeight: "1",
            width: "20px",
            textAlign: "center",
            flexShrink: 0,
          }}
        >
          ▼
        </span>
      </button>
      {open && (
        <div
          style={{
            backgroundColor: "#FFFFFF",
            padding: "16px 12px",
            borderTop: "1px solid #F0F0F0",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapsible;
